import { ContentAccountSettingsResponse, ContentAccountSettingsUpdateResponse, ContentLongformPreviewResponse, ContentLongformRunListResponse, } from '@wit-support/admin-contracts';
import { CONTENT_API_BASE as BASE, ContentRequestError, contentJsonInit as jsonInit, contentQs as qs, contentRequest as request, } from '../api.js';
/**
 * Длинные ролики и обложки (engage-1009 §2.7, §3.5): настройки аккаунтов,
 * история прогонов слота и предпросмотр следующего состава.
 *
 * Ключи — внутри `CONTENT_KEY`: правка настроек сбрасывает раздел целиком.
 */
export const CONTENT_ACCOUNT_SETTINGS_KEY = ['content', 'account-settings'];
export const CONTENT_LONGFORM_RUNS_KEY = ['content', 'longform-runs'];
/** GET /account-settings — длинные ролики, обложки и слот по каждому аккаунту. */
export function getAccountSettings() {
    return request(ContentAccountSettingsResponse, `${BASE}/account-settings`);
}
/**
 * PUT /account-settings (content.manage, аудит). Отправляются только
 * изменённые поля; сочетание с сохранёнными значениями проверяет движок
 * (400 `upstream_rejected` с русской фразой).
 */
export function updateAccountSettings(body) {
    return request(ContentAccountSettingsUpdateResponse, `${BASE}/account-settings`, jsonInit('PUT', body));
}
/** GET /longform/runs — прогоны слотов, новые сверху, постранично. */
export function listLongformRuns(q) {
    return request(ContentLongformRunListResponse, `${BASE}/longform/runs${qs({
        account: q.account,
        page: String(q.page),
        pageSize: String(q.pageSize),
    })}`);
}
/** Фраза admin-api на `longform_not_enabled`, если её почему-то нет. */
const ENGINE_OFF_FALLBACK = 'Длинные ролики в движке выключены.';
/** Код движка: флаг длинных роликов (`ENGINE_LONGFORM`) выключен. */
export const LONGFORM_NOT_ENABLED_CODE = 'longform_not_enabled';
/**
 * POST /longform/preview (content.manage) — ничего не записывает.
 *
 * «Выключено в движке» распознаётся по коду движка `longform_not_enabled`
 * (`ContentRequestError.upstreamCode`), а не по статусу: любой другой отказ
 * (в том числе другой 409) — обычная ошибка, её показывает экран.
 */
export async function previewLongform(account) {
    try {
        const preview = await request(ContentLongformPreviewResponse, `${BASE}/longform/preview`, jsonInit('POST', { account }));
        return { kind: 'ready', preview };
    }
    catch (err) {
        if (err instanceof ContentRequestError && err.upstreamCode === LONGFORM_NOT_ENABLED_CODE) {
            return { kind: 'engine_off', message: err.message || ENGINE_OFF_FALLBACK };
        }
        throw err;
    }
}
//# sourceMappingURL=video-settings.js.map